import React, {useState} from 'react';
import {
    Accordion,
    AccordionDetails, AccordionGroup,
    AccordionSummary,
    Avatar,
    Box,
    Grid,
    IconButton,
    Menu,
    Sheet,
    Stack
} from '@mui/joy';
import Skill from "./Skill";
import {Add, Check, Circle, ExpandMore, Minimize} from "@mui/icons-material";
import {EducationModel} from "../model/education";
import {ExperienceModel} from "../model/experience";
import {SkillModel} from "../model/skill";
import {ServiceModel} from "../model/service";
import Typography from "@mui/joy/Typography";
import SkillGroup from "./SkillGroup";

function Skills({skills}: { skills: Array<SkillModel> }) {

    const [expandedGroup, setExpandedGroup] = useState<Map<string, boolean>>();
    const skillsGroup: Map<string, Array<SkillModel>> = new Map<string, Array<SkillModel>>();
    const skillsGroupComponentArray: Array<React.ReactNode> = [];

    function getOriginalWord(word: string): string {
        let originalWord = '';
        word.split('').forEach((value, index) => {
            if (value.toUpperCase() == value) {
                originalWord += " " + value
            } else {
                if (index == 0)
                    originalWord += value.toUpperCase();
                else
                    originalWord += value;
            }
        })
        return originalWord;
    }

    const skillsSorted = skills.sort((a, b) => a.orderNumber - b.orderNumber)
    skillsSorted.forEach(value => {
        if (!skillsGroup.has(value.category)) {
            skillsGroup.set(value.category, [value])
        } else {
            skillsGroup.get(value.category)?.push(value)
        }
    })

    skillsGroup.forEach((value, key) => {
        skillsGroupComponentArray.push(<SkillGroup name={getOriginalWord(key)} skills={value}/>)
    })

    return (
        <Stack direction='row' sx={{justifyContent: 'space-around', alignItems: 'flex-start', borderRadius: 8,}}>
            <Box display={{xs: 'none', lg: 'block'}}>
                <Avatar sx={{width: 128, height: 128}} size='sm' variant='soft' color='primary'>
                    <Circle sx={{fontSize: 128}}/>
                </Avatar>
            </Box>
            <Sheet
                sx={{
                    paddingY: 2,
                    paddingX: 0,
                    width: '100%',
                    maxWidth: 800,
                    borderRadius: 16,
                }}>
                <Stack direction='column' spacing={4}>
                    <AccordionGroup>
                        {
                            skillsGroupComponentArray
                        }
                    </AccordionGroup>
                </Stack>
            </Sheet>
        </Stack>
    );
}

export default Skills;